<template>
  <div>
    <div class="mtabs sa-mob-cont" v-if="!ViewRecordFlag">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">Patient record details</h5>
        <button class="sa-btn-back" @click="$parent.patientRecordFlag = false">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-tabs sa-btn-tabs">
        <div class="sa-pname sa-h-sm-up">
          <span class="img-ico m-r10 el-avatar">AJ</span><span>Adam jhone</span>
        </div>
        <div class="tab-active">
          <a
            v-on:click="tabSelection = 'records'"
            v-bind:class="[tabSelection === 'records' ? 'active' : '']"
            >Records</a
          >
          <a
            v-on:click="tabSelection = 'personal'"
            @click="viewPersonal"
            v-bind:class="[tabSelection === 'personal' ? 'active' : '']"
            >Personal</a
          >
          <!-- <a class="sa-h-xs" v-on:click="tabSelection = 'health'" v-bind:class="[tabSelection === 'health' ? 'active' : '']">Health</a> -->
          <a
            v-on:click="tabSelection = 'medical'"
            @click="viewMedical"
            v-bind:class="[tabSelection === 'medical' ? 'active' : '']"
            >Medical</a
          >
          <a
            v-on:click="tabSelection = 'lifestyle'"
            @click="viewLifestyle"
            v-bind:class="[tabSelection === 'lifestyle' ? 'active' : '']"
            >Life style</a
          >
        </div>
      </div>
      <div class="sa-tab-cont" :tabSelection="tabSelection">
        <div v-if="tabSelection === 'records'">
          <div class="sa-d-f-sbetween" v-if="records.records.length">
            <h5 class="sa-card-tit d-inline">Records</h5>
            <span
              ><i class="icon-filter sa-ml10 sa-blue-text"></i
              ><i class="icon-files sa-ml20"></i
              ><span class="sa-ml10">{{ records.records.length }}</span></span
            >
          </div>
          <swiper
            class="sa-customslider swiper"
            ref="mySwiper"
            :options="swiperOption"
            v-if="records.records.length"
          >
            <swiper-slide v-for="(n, i) in records.records" :key="i">
              <div class="sa-card sa-cursor" @click="openViewRecord(n)">
                <i
                  v-if="n.cat_nm == 'Radiology'"
                  class="sa-sprite sa-lung-img"
                ></i>
                <i v-else class="sa-sprite sa-lab-reports"></i>
                <h6>{{ n.cat_nm }}</h6>
                <small class="sa-blue-text">{{ n.file_nm }}</small>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
          <div class="sa-d-f-sbetween">
            <h5 class="sa-card-tit">Bookings</h5>
            <span
              ><i class="icon-filter sa-ml10 sa-blue-text"></i
              ><i class="icon-calendar sa-ml20"></i
              ><span class="sa-blue-text sa-ml10">{{
                records.bookings.length
              }}</span></span
            >
          </div>
          <ul class="sa-date-list">
            <li
              @click="apntView(n)"
              v-for="(n, i) in records.bookings"
              :key="i"
            >
              <div class="sa-booking-date sa-mdata">{{ n.date }}</div>
              <div class="sa-card sa-card-gray sa-card-noshadow">
                <div class="sa-card-list-box">
                  <figure class="sa-avt-img">
                    <img
                      :src="n.img ? n.img : imageUrl"
                      alt="Doctor"
                      class="sa-img-cover"
                    />
                  </figure>
                  <div class="sa-doct-det">
                    <h6>{{ n.name }}</h6>
                  </div>
                  <div class="sa-doct-apoint">
                    Appoiment ID :<span class="sa-black-text"
                      >{{ n.apnt_id }}
                    </span>
                    <span class="sa-blue-text sa-ml15">{{ n.srvc }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="tabSelection === 'personal' && personal">
          <ul class="sa-mpersonal">
            <li>
              Name<span>{{ personal.name }}</span>
            </li>
            <li>
              Relation<span>{{ personal.relation }}</span>
            </li>
            <li>
              Gender<span>{{ personal.gnd }}</span>
            </li>
            <li>
              Date of birth<span>{{ personal.dob }}</span>
            </li>
            <li>
              Age<span>{{ personal.age }}</span>
            </li>
            <li>
              Phone number (optional)<span>{{ personal.ph }}</span>
            </li>
            <!-- <li>Insurence details<span class="sa-sprite sa-insurance"> {{personal.insurance}}</span></li> -->
          </ul>

          <h5 class="sa-mt30 sa-mb20">Additional Information</h5>
          <ul class="sa-mpersonal">
            <li>
              Marital status<span>{{ personal.marr }}</span>
            </li>
            <li>
              Height & Weight<span
                >{{ personal.hgt }} Feet, {{ personal.wgt }} Kg</span
              >
            </li>
            <!-- <li>Name<span>Michel Miller</span></li> -->
            <li>
              Blood Group<span>{{ personal.blood }}</span>
            </li>
          </ul>
        </div>
        <div v-if="tabSelection === 'medical' && medical">
          <ul class="sa-mpersonal">
            <li>
              Allergies<span v-if="medical && medical.allergies">{{
                medical.allergies
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Current medication<span v-if="medical && medical.current_med">{{
                medical.current_med
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Past medication<span v-if="medical && medical.past_med">{{
                medical.past_med
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Injuries<span v-if="medical && medical.injuries">{{
                medical.injuries
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Surgeries<span v-if="medical && medical.surgeries">{{
                medical.surgeries
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Chronic Disease<span v-if="medical && medical.cronic_deceases">{{
                medical.cronic_deceases
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
          </ul>
        </div>
        <div v-if="tabSelection === 'lifestyle' && lifestyle">
          <ul class="sa-mpersonal">
            <li>
              Smoking Habits<span v-if="lifestyle && lifestyle.smoking">{{
                lifestyle.smoking
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Activity Level<span v-if="lifestyle && lifestyle.activity">{{
                lifestyle.activity
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Food Preference<span v-if="lifestyle && lifestyle.food">{{
                lifestyle.food
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
            <li>
              Occupation<span v-if="lifestyle && lifestyle.occu">{{
                lifestyle.occu
              }}</span
              ><span v-else>Not Submitted</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <view-record :records="records" :recordObj="recordObj" v-else />
  </div>
</template>
<script>
import ViewRecordVue from "./ViewRecord.vue";
import { pro_url } from "../../../config/endpoints";
export default {
  components: {
    "view-record": ViewRecordVue,
  },
  props: ["records", "apnt"],
  data() {
    return {
      imageUrl: "https://img.litedev.com/images/unknown-avtar.png",
      openViewRecordFlag: false,
      ViewRecordFlag: false,
      tabSelection: "records",
      recordObj: null,
      personal: null,
      medical: null,
      lifestyle: null,
      clinicInfoReq: "",
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          414: {
            slidesPerView: 2.5,
            spaceBetween: 8,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
        },
      },
    };
  },
  methods: {
    openViewRecord(n) {
      this.recordObj = n;
      if (!this.openViewRecordFlag) {
        (this.openViewRecordFlag = true), (this.ViewRecordFlag = true);
      } else {
        (this.openViewRecordFlag = false), (this.ViewRecordFlag = false);
      }
    },
    viewPersonal() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/recordDetails`,
          body: {
            apnt_id: _self.apnt.apnt_id,
            mtype: "personal",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.personal = response.data;
          }
        });
    },
    viewMedical() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/recordDetails`,
          body: {
            apnt_id: _self.apnt.apnt_id,
            mtype: "medical",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.medical = response.data;
          }
        });
    },
    viewLifestyle() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/recordDetails`,
          body: {
            apnt_id: _self.apnt.apnt_id,
            mtype: "lifestyle",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.lifestyle = response.data;
          }
        });
    },
    apntView(n) {
      if (n.utid == "1") {
        this.$router.push(
          "/appointments/doctor-details/review-diagnosis/" + n.apnt_id
        );
      } else if (n.utid == "2") {
        this.$router.push("/appointments/physio-details/" + n.apnt_id);
      } else if (n.utid == "3") {
        this.$router.push("/appointments/nurse-details/" + n.apnt_id);
      } else {
        this.$router.push("/appointments/labtech-details/" + n.apnt_id);
      }
    },
  },
};
</script>
